(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-root]').forEach(product => {
      if (product.dataset.bound) return;
      product.dataset.bound = 'true';
      const select = product.querySelector('[data-variant-select]');
      const image = product.querySelector('[data-product-image]');
      const price = product.querySelector('[data-product-price]');
      const add = product.querySelector('[data-add-button]');
      const change = () => {
        const option = select?.selectedOptions[0];
        if (!option) return;
        if (image && option.dataset.image) image.src = option.dataset.image;
        if (image) image.alt = `Collier Lumidog — ${option.textContent.trim()}`;
        if (price) price.textContent = option.dataset.price;
        if (add) {
          add.disabled = option.dataset.available !== 'true';
          add.textContent = add.disabled ? 'Épuisé' : 'Ajouter au panier';
        }
        if (location.pathname.includes('/products/')) {
          const url = new URL(location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState(null, '', url);
        }
      };
      select?.addEventListener('change', change);
      product.querySelectorAll('[data-gallery-image]').forEach(button => {
        button.addEventListener('click', () => {
          if (!image) return;
          if (select && button.dataset.galleryColor) {
            const currentSize = select.selectedOptions[0]?.textContent.split(' / ').slice(1).join(' / ').replace(' — Épuisé', '').trim();
            const candidates = Array.from(select.options).filter(option => option.textContent.toLowerCase().startsWith(button.dataset.galleryColor));
            const matchingSize = candidates.find(option => option.textContent.split(' / ').slice(1).join(' / ').replace(' — Épuisé', '').trim() === currentSize);
            const match = matchingSize || candidates[0];
            if (match) { select.value = match.value; change(); }
          }
          image.src = button.dataset.galleryImage;
          image.alt = button.dataset.galleryAlt || button.getAttribute('aria-label');
        });
      });
    });
    root.querySelector('[data-contact-success]')?.focus();
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
